export default class OrderObservationModel {}
